





import ButtonSwitch from '@/shared/components/button-switch.component.vue';
import { Component, Vue } from 'vue-property-decorator';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';

@Component({
  components: {
    ButtonSwitch,
    ExpansionPanel,
  },
})
export default class PartialButtonSwitch extends Vue {
  private switchOption = {
    id: 1,
    text: 'Asistentes',
  };
  private switchOptions = [
    {
      id: 1,
      text: 'Asistentes',
    },
    {
      id: 2,
      text: 'Repetidores',
    },
  ];

  private optionSelected(option: any) {
    this.switchOption = option;
  }
}
